// Page/component translations — English (en)
export const pagesEn: Record<string, string> = {
  // COMMON
  loading: 'Loading...',
  saving: 'Saving...',
  deleting: 'Deleting...',
  processing: 'Processing...',
  errorLabel: 'Error',
  successLabel: 'Success',
  notAuthenticated: 'User not authenticated',
  tryAgain: 'Try again',
  noData: 'No data available',
  copiedToClipboard: 'Copied to clipboard',
  requiredField: 'Required field',
  invalidEmailMsg: 'Invalid email',
  loadingVideos: 'Loading videos...',
  noVideosFound: 'No videos found',
  unknownError: 'Unknown error',
  confirmDelete: 'Confirm deletion',
  saveError: 'Error saving',
  loadingEllipsis: 'Loading...',
  loadingDataEllipsis: 'Loading data...',

  // AUTH
  loginTitle: 'Access your account',
  loginSubtitle: 'Everything to scale VSLs with automation, protection and metrics.',
  loginSuccess: 'Login successful!',
  loginError: 'Login error. Check your credentials.',
  loginErrorGeneric: 'Login error. Try again.',
  enterButton: 'Sign in',
  enteringButton: 'Signing in...',
  stayConnected: 'Stay connected',
  forgotPassword: 'Forgot your password?',
  noAccount: "Don't have an account?",
  createAccountFree: 'Create your free account here now',
  signupTitle: 'Create your account',
  signupSubtitle: 'And start turning videos into real conversions.',
  signupSuccess: 'Account created successfully! Now choose your plan to get started.',
  signupError: 'Error creating account. Try again.',
  acceptTermsError: 'You need to accept the terms of use to continue.',
  passwordError: 'The passwords must be the same.',
  userAlreadyExists: 'This user already has an account on the platform.',
  nameTooShort: 'Name must have at least 2 characters.',
  invalidCPF: 'Invalid CPF.',
  invalidWhatsApp: 'Invalid WhatsApp.',
  passwordTooShort: 'Password must have at least 8 characters.',
  alreadyHaveAccount: 'Already have an account?',
  loginHereLink: 'Log in here',
  namePlaceholder: 'Full name',
  emailPlaceholder: 'youremail@domain.com',
  passwordPlaceholder: 'Min. 8 characters',
  emailLabel: 'Email',
  passwordLabel: 'Password',
  passwordLabelMatch: 'Retype Password',
  acceptTermsLabel: 'I accept the terms of use and privacy policy',

  // DASHBOARD / MY VIDEOS
  deleteVideoSuccess: 'Video deleted successfully!',
  deleteVideoError: 'Error deleting video',
  moveVideoSuccess: 'Video moved to folder successfully!',
  moveVideoError: 'Error moving video to folder',
  videoRemovedFromFolder: 'Video removed from folder!',
  searchVideosPlaceholder: 'Search videos...',
  noVideosInFolder: 'No videos in this folder',
  newFolderLabel: 'New folder',
  gridViewLabel: 'Grid view',
  listViewLabel: 'List view',
  myVideosPageTitle: 'My Videos',
  manageVideosSubtitle: 'Manage and view your latest videos',

  // A/B TEST
  incompleteConfig: 'Incomplete configuration',
  mainVideoNotSelected: 'Main video not selected',
  abTestActive: 'Your A/B test is active',
  videoSelectionTab: 'Video selection',
  trafficDistributionTab: 'Traffic distribution',
  testDeletedMsg: 'Test deleted',
  cannotDeleteTest: 'Could not delete test',
  createFirstABTest: 'Create your first A/B test',
  abTestEmptyDesc: 'Test different versions of your VSLs and discover what converts more',
  createABTestBtn: 'Create A/B Test',
  howItWorksLink: 'How does it work?',
  trafficUpdatedSuccess: 'Distribution updated',
  trafficUpdatedDesc: 'Traffic distribution updated successfully',
  selectMinVideos: 'Select at least 2 videos for the test',
  selectMaxVideos: 'Select at most 6 videos for the test',
  dateNotAvailable: 'Date not available',
  invalidDate: 'Invalid date',
  runningStatus: 'Running',
  finishedStatus: 'Finished',
  authError: 'Authentication error',

  // HOOK TRACK
  hookTestActive: 'Your hook test is active',
  hookTrackEmptyDesc: 'Test different hooks and discover which retains attention the most',
  createFirstHookTest: 'Create your first hook test',

  // VSLEADS
  loadStrategiesError: 'Error loading strategies',
  strategyUpdatedToast: 'Strategy updated',
  strategyUpdatedSuccessMsg: 'Strategy updated successfully.',
  strategyRemovedToast: 'Strategy removed',
  loadingStrategies: 'Loading strategies...',
  leadCaptureTitle: 'Lead Capture',
  captureWithEmailLabel: 'Capture with Email',
  captureWithPasswordLabel: 'Capture with Password',
  loadStrategyError: 'Error loading strategy',
  strategyUpdateSuccess: 'Strategy updated successfully',
  updateStrategyError: 'Error updating strategy',
  protectedContent: 'Protected content',
  accessVideoBtn: 'Access video',
  strategyCreated: 'Strategy created successfully',
  saveStrategyError: 'Error saving strategy',

  // VSL CLOAKER
  loadVideosError: 'Error loading videos',
  loadRulesError: 'Error loading rules',
  selectOriginalVideo: 'Select original video',
  ruleCreated: 'Rule created successfully',
  ruleDeleted: 'Rule deleted successfully',
  codesCopied: 'Code copied!',
  cloakerEmptyTitle: 'No rules created',
  cloakerEmptyDesc: 'Create rules to filter and redirect traffic based on criteria',

  // UPLOAD
  invalidFormat: 'Invalid format',
  selectVideoFilesOnly: 'Select only video files',
  videosAddedToast: 'Videos added',
  uploadsCompleted: 'Uploads completed',
  maxFileSizeError: 'File must be at most 100MB',
  unsupportedFormatMsg: 'Unsupported format',
  videoNameLabel: 'Video name',
  continueToCustomize: 'Continue to customize your video',
  myVideoDefault: 'My Video',

  // METRICS
  noRetentionData: 'No retention data in period',
  noUTMData: 'No UTM data in period',
  expandPeriodTip: 'Try expanding the period',
  saveErrorMsg: 'Error saving',
  videoTimeLabel: 'Video Time',
  retentionLabel: 'Retention (%)',

  // PLAYLIST
  playlistDeletedMsg: 'Playlist deleted',
  playlistLinkCopied: 'Playlist link copied',
  playlistNotFound: 'Playlist not found',
  videosAddedMsg: 'Videos added!',
  videoRemovedMsg: 'Video removed',
  videosAddedSuccessDesc: 'Videos saved successfully.',
  embedCodeCopiedMsg: 'Code copied!',
  embedCodeCopiedDesc: 'Embed code copied to clipboard.',
  logoCompressed: 'Logo optimized',
  logoError: 'Error compressing logo',
  faviconError: 'Error compressing favicon',
  addVideosTitle: 'Add videos',

  // SHARE VIDEO
  settingsSaved: 'Settings saved!',
  generatingPublicLink: 'Generating public link',
  activatingMetrics: 'Activating metrics',
  videoPreparing: 'Video preparing',
  copiesLabel: 'copies',
  copyLabel: 'copy',

  // WEBINAR
  invalidWhatsAppField: 'Invalid WhatsApp',
  registrationSuccess: 'Registration done!',
  redirectingToRoom: 'You will be redirected to the room...',
  formError: 'Form error',

  // NOTIFICATIONS
  notificationsSaved: 'Preferences saved',
  notificationsEnabled: 'Notifications enabled!',
  notificationPermissionNeeded: 'Permission required',
  testNotification: 'Test notification',
  installAvailable: 'HostVSL is being installed',
  installInfo: 'You can access HostVSL from your home screen',
  installNotAvailable: 'Installation not available',

  // FEATURE CONFIGS
  urlInvalid: 'Invalid URL',
  unsupportedImageFormat: 'Unsupported format. Use PNG or JPG',
  thumbnailConfigured: 'Start thumbnail configured',
  buttonAdded: 'Button added',
  buttonRemoved: 'Button removed',
  videoIdNotFound: 'Video ID not found',

  // DASHBOARD EMPTY STATES
  emptyDashboardTitle: 'No videos found',
  emptyDashboardSubtitle: 'Upload your first video to get started',
  uploadFirstVideo: 'Upload first video',

  // PROFILE
  profileSaved: 'Profile saved',
  passwordChangedSuccess: 'Password changed successfully',
  photoChangedSuccess: 'Photo changed',
  photoRemovedSuccess: 'Photo removed',

  // PIXEL
  pixelPageTitle: 'Pixel Configuration',
  pixelPageSubtitle: 'Configure tracking pixels to monitor conversions',

  // METRICS PAGE
  metricsPageTitle: 'Metrics',
  selectVideoMetrics: 'Select a video to see metrics',

  // DOMAIN PROTECTION
  domainProtectionTitle: 'Domain Protection',

  // TRACKING
  trackingTitle: 'Tracking',

  // FINANCE
  financeTitle: 'Finance',

  // PARTNERS
  partnersTitle: 'Partners',

  // NOT FOUND
  pageNotFound: 'Page not found',
  goHome: 'Back to home',

  // AB TEST LIST
  abTestListTitle: 'Your A/B Tests',
  createNewTest: 'Create new test',
  noABTestsFound: 'No A/B tests found',
  createFirstABTestDesc: 'Create your first A/B test to compare different video versions.',
  copyCode: 'Copy Code',
  rename: 'Rename',
  viewMetrics: 'View Metrics',
  deleteABTestTitle: 'Delete A/B test?',
  deleteTestConfirm: 'This action will permanently delete this test and all its data. This action cannot be undone.',
  confirmDeleteTest: 'Yes, delete test',
  abTestCodeCopiedDesc: 'The A/B test code has been copied to the clipboard.',
  abTestDeletedDesc: 'The A/B test has been deleted successfully.',
  deleteErrorTitle: 'Delete error',
  testRenamedTitle: 'Test renamed',
  testRenamedDesc: 'The test name has been updated successfully.',
  renameErrorTitle: 'Rename error',
  renameTestError: 'Could not rename the test.',
  copyCodeErrorTitle: 'Code copy error',
  noVideosInTest: 'This test has no associated videos.',
  featureInDevelopment: 'In development',
  toggleStatusDev: 'Enable/disable feature is in development.',
  duplicateDev: 'Duplicate feature is in development.',

  // HOOK TRACK LIST
  hookTrackListTitle: 'Your Hook Tests',
  createHookTest: 'Create Hook Test',
  noHookTestsDesc: "You haven't created any hook tests yet.",
  createFirstHookLabel: 'Create your first test',
  deleteHookTestTitle: 'Delete hook test?',
  hookTestDeletedDesc: 'The test has been deleted successfully.',
  hookRenameTestError: 'Could not update the test name.',
  statusUpdatedTitle: 'Status updated',
  statusUpdatedDesc: 'The test status has been updated.',
  duplicateSoon: 'Duplication feature coming soon.',
  testWithoutName: 'Unnamed test',

  // MY VIDEOS V2
  removeFromFolderError: 'Error removing video from folder',
};
